const SancionadosIcon = ({ iconWidth, iconHeight, color = '#e11d48' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={iconWidth} height={iconHeight} viewBox="0 0 448 512">
            <path
                fill={color}
                d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48"
            />
        </svg>
    );
};

export default SancionadosIcon;
